<div role="status" class="w-full animate-pulse">
  <div
    class="bg-gray-200 dark:bg-gray-700 w-full mb-4"
    [ngClass]="{ 'h-40': size === 'lg', 'h-20': size === 'md', 'h-10': size === 'xs' }"
  ></div>
</div>
